import React from "react";
import axios from "../../axios-atis";
import validator from "validator";
import moment from "moment";
import {
  ControlLabel,
  Form,
  Button,
  Modal,
  Checkbox,
  FormGroup,
  Col,
  FormControl,
  InputGroup,
} from "react-bootstrap";
import "react-datepicker/dist/react-datepicker.css";

import { isA } from "../../store/utility";
import * as UIConstants from "../../components/UI/UIConstants";

export default class NewUserModal extends React.Component {
  constructor(props) {
    super(props);
    var idLocale = require("moment/locale/fr");
    moment.locale("id", idLocale);

    this.state = {
      title: { value: "", isValid: true, message: "" },
      forname: { value: "", isValid: true, message: "" },
      name: { value: "", isValid: true, message: "" },
      username: { value: "", isValid: true, message: "" },
      company: { value: "0", isValid: false, message: "Choisir une compagnie" },
      pwd1: { value: "", isValid: true, message: "" },
      pwd2: { value: "", isValid: true, message: "" },
      role: { value: "USER", isValid: true, message: "" },
      email: { value: "", isValid: true, message: "" },
      phone: { value: "", isValid: true, message: "" },
      cellular: { value: "", isValid: true, message: "" },
      activated: { value: true, isValid: true, message: "" },
      changeKey: false,
      generateAppKey: null,
      passLength: 0,
    };
  }

  inputChangeHandler = (event) => {
    
    var state = this.state;
    state[event.target.id].value = event.target.value;
    if (event.target.id === "company" && parseInt(event.target.value, 10) > 0) {
      state[event.target.id].isValid = true;
      state[event.target.id].message = "";
    }
    this.setState(state);
  };

  resetValidationStates = () => {
    var state = this.state;

    Object.keys(state).map((key) => {
      if (null !== state[key] && state[key].hasOwnProperty("isValid")) {
        state[key].isValid = true;
        state[key].message = "";
      }
      return true;
    });
    this.setState(state);
  };

  isFormValid = () => {
    var state = this.state;
    if (!validator.isLength(state.username.value, 6)) {
      state.username.message = "Au moins 6 caractères";
      state.username.isValid = false;
    } else {
      state.username.message = "";
      state.username.isValid = true;
    }
    if (parseInt(state.company.value, 10) > 0) {
      state.company.isValid = true;
      state.company.message = "";
    } else {
      state.company.isValid = false;
      state.company.message = "Choisir une compagnie";
    }
    if (!validator.isLength(state.pwd1.value, 8)) {
      state.pwd1.message = "Au moins 8 caractères";
      state.pwd1.isValid = false;
    }
    if (state.pwd1.value !== state.pwd2.value) {
      state.pwd2.message = "Les mots de passe sont différents";
      state.pwd2.isValid = false;
    }
    if (state.email.value && !validator.isEmail(state.email.value)) {
      state.email.message = "Format Email incorrecte";
      state.email.isValid = false;
    }

    this.setState(state);
    var isValid = true;
    Object.keys(state).map((key) => {
      
      if (null !== state[key] && state[key].hasOwnProperty("isValid")) {
        if (!state[key].isValid) {
          isValid = false;
          return true;
        }
      }
      return true;
    });
    
    return isValid;
  };

  validateForm = () => {
    return (
      this.state.username.value.length > 0 &&
      this.state.pwd1.value.length > 0 &&
      this.state.pwd2.value.length &&
      parseInt(this.state.company.value, 10) > 0
    );
  };

  submitHandler = (event) => {
    event.preventDefault();
    event.stopPropagation();
    
    if (this.isFormValid()) {
      const url = "/users/check";
      const checkUserNameData = {
        username: this.state.username.value,
      };
      axios.post(url, checkUserNameData).then((response) => {
        if (response && response.data.status !== 202) {
          var state = this.state;
          state.username.message = response.data.message;
          state.username.isValid = false;
          this.setState(state);
        } else {
          const user = {
            title: this.state.title.value,
            forname: this.state.forname.value,
            name: this.state.name.value,
            username: this.state.username.value,
            company: this.state.company.value,
            pwd: this.state.pwd1.value,
            role: this.state.role.value,
            email: this.state.email.value,
            phone: this.state.phone.value,
            cellular: this.state.cellular.value,
            activated: this.state.activated.value,
          }
          this.props.saveOrUpdate(user);
          this.resetValues();
          this.resetValidationStates();
        }
      });
    } 
  };

  generateKey = (event) => {
    event.preventDefault();
    var state = this.state;
    const url = "/users/generateKey";
    axios
      .post(url)
      .then((response) => {
        state.setState({ generateAppKey: response.data });
      })
      .catch((err) => {
        state.generateAppKey = null;
      });
    this.setState(state);
  };

  appKeyChangeHandler = (event) => {
    event.preventDefault();
    var val = this.state.changeKey;
    this.setState({ changeKey: !val });
  };

  resetValues = () => {
    this.setState({
      title: { value: "", isValid: true, message: "" },
      forname: { value: "", isValid: true, message: "" },
      name: { value: "", isValid: true, message: "" },
      username: { value: "", isValid: true, message: "" },
      company: { value: "0", isValid: false, message: "Choisir une compagnie" },
      pwd1: { value: "", isValid: true, message: "" },
      pwd2: { value: "", isValid: true, message: "" },
      role: { value: "USER", isValid: true, message: "" },
      email: { value: "", isValid: true, message: "" },
      phone: { value: "", isValid: true, message: "" },
      cellular: { value: "", isValid: true, message: "" },
      activated: { value: true, isValid: true, message: "" },
      changeKey: false,
      generateAppKey: null,
      passLength: 0,
    });
  }

  render() {
    const myCompanies = this.props.data;

    if (null === myCompanies || undefined === myCompanies) {
      return null;
    }
    return (
      <Modal {...this.props} onExit={this.resetValues} bsSize="large">
        <Modal.Header closeButton>
          <Modal.Title>
            <span>Création utilisateur</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form horizontal onSubmit={this.submitHandler}>
            <FormGroup>
              <Col componentClass={ControlLabel} sm={2}>
                Titre
              </Col>
              <Col sm={2}>
                <FormControl
                  componentClass="select"
                  id="title"
                  value={this.state.title.value}
                  onChange={(event) => this.inputChangeHandler(event)}
                >
                  {UIConstants.USER_TITLE.map((title) => {
                    return (
                      <option key={title.name} value={title.name}>
                        {title.label}
                      </option>
                    );
                  })}
                  ;
                </FormControl>
              </Col>
              <Col componentClass={ControlLabel} sm={4}>
                Actif
              </Col>
              <Col sm={4}>
                <label className="switch">
                  {this.state.activated.value ? (
                    <input id="activated" type="checkbox" defaultChecked />
                  ) : (
                    <input id="activated" type="checkbox" />
                  )}
                  <em />
                </label>
              </Col>
            </FormGroup>
            <FormGroup>
              <Col componentClass={ControlLabel} sm={2}>
                Prénom
              </Col>
              <Col sm={4}>
                <FormControl
                  type="text"
                  id="forname"
                  className="form-control"
                  value={this.state.forname.value}
                  onChange={(event) => this.inputChangeHandler(event)}
                  placeholder="Prénom"
                />
                <span style={UIConstants.ERROR_SPAN_STYLE}>
                  {this.state.forname.message}
                </span>
              </Col>
              <Col componentClass={ControlLabel} sm={2}>
                Nom
              </Col>
              <Col sm={4}>
                <FormControl
                  type="text"
                  id="name"
                  className="form-control"
                  value={this.state.name.value}
                  placeholder="Nom"
                  onChange={(event) => this.inputChangeHandler(event)}
                />
                <span style={UIConstants.ERROR_SPAN_STYLE}>
                  {this.state.name.message}
                </span>
              </Col>
            </FormGroup>
            <FormGroup>
              <Col componentClass={ControlLabel} sm={2}>
                Login *
              </Col>
              <Col sm={4}>
                <InputGroup>
                  <InputGroup.Addon>
                    <span className="fa fa-user" />
                  </InputGroup.Addon>
                  <FormControl
                    type="text"
                    id="username"
                    className="form-control"
                    value={this.state.username.value}
                    placeholder="Login"
                    onChange={(event) => this.inputChangeHandler(event)}
                    required="required"
                  />
                </InputGroup>
                <span style={UIConstants.ERROR_SPAN_STYLE}>
                  {this.state.username.message}
                </span>
              </Col>
              {isA() ? (
                <React.Fragment>
                  <Col componentClass={ControlLabel} sm={2}>
                    Société *
                  </Col>
                  <Col sm={4}>
                    <FormControl
                      componentClass="select"
                      placeholder="Compagnie"
                      id="company"
                      value={this.state.company.value}
                      onChange={(event) => this.inputChangeHandler(event)}
                    >
                      <option key="choose company" value="0">
                        Choisir ----
                      </option>
                      {myCompanies.map((company) => {
                        return (
                          <option key={company.id} value={company.id}>
                            {company.name}
                          </option>
                        );
                      })}
                      ;
                    </FormControl>
                    <span style={UIConstants.ERROR_SPAN_STYLE}>
                      {this.state.company.message}
                    </span>
                  </Col>
                </React.Fragment>
              ) : null}
              { /*}
              <Col componentClass={ControlLabel} sm={2}>
                Role *
              </Col>
              <Col sm={4}>
                <FormControl
                  componentClass="select"
                  placeholder="Role"
                  id="role"
                  value={this.state.role.value}
                  onChange={(event) => this.inputChangeHandler(event)}
                >
                  {isA()
                    ? UIConstants.USER_ADMIN_ROLES.map((role) => {
                        return (
                          <option key={role.name} value={role.name}>
                            {role.label}
                          </option>
                        );
                      })
                    : UIConstants.USER_ROLES.map((role) => {
                        return (
                          <option key={role.name} value={role.name}>
                            {role.label}
                          </option>
                        );
                      })}
                </FormControl>
              </Col>
              { */}
            </FormGroup>
            
            {/*isA() ? (
              <FormGroup>
                <Col componentClass={ControlLabel} sm={2}>
                  Clé android :
                </Col>
                <Col sm={6}>
                  <FormControl
                    type="text"
                    id="appKey"
                    value={
                      this.state.generateAppKey === null
                        ? ""
                        : this.state.generateAppKey
                    }
                    placeholder="Clé application Androïd"
                    disabled={true}
                  />
                </Col>
                <Col sm={4}>
                  {this.state.generateAppKey === null ||
                  this.state.changeKey ? (
                    <Button onClick={(event) => this.generateKey(event)}>
                      Générer
                    </Button>
                  ) : null}
                  {this.state.generateAppKey !== null ? (
                    <Checkbox
                      onChange={(event) => this.appKeyChangeHandler(event)}
                    >
                      Changer la clé
                    </Checkbox>
                  ) : null}
                </Col>
              </FormGroup>
            ) : null*/}
            <FormGroup>
              <Col componentClass={ControlLabel} sm={2}>
                Mot de passe *
              </Col>
              <Col sm={5}>
                <FormControl
                  type="password"
                  id="pwd1"
                  placeholder="Mot de passe"
                  className="form-control"
                  value={this.state.pwd1.value}
                  onChange={(event) => this.inputChangeHandler(event)}
                />
                <span style={UIConstants.ERROR_SPAN_STYLE}>
                  {this.state.pwd1.message}
                </span>
              </Col>
              <Col sm={5}>
                <FormControl
                  type="password"
                  id="pwd2"
                  placeholder="vérification Mot de passe"
                  className="form-control"
                  value={this.state.pwd2.value}
                  onChange={(event) => this.inputChangeHandler(event)}
                />
                <span style={UIConstants.ERROR_SPAN_STYLE}>
                  {this.state.pwd2.message}
                </span>
              </Col>
            </FormGroup>
            <FormGroup>
              <Col componentClass={ControlLabel} sm={2}>
                Email
              </Col>
              <Col sm={10}>
                <InputGroup>
                  <InputGroup.Addon>@</InputGroup.Addon>
                  <FormControl
                    type="email"
                    id="email"
                    className="form-control"
                    value={this.state.email.value}
                    placeholder="Adresse électronique"
                    onChange={(event) => this.inputChangeHandler(event)}
                  />
                </InputGroup>
                <span style={UIConstants.ERROR_SPAN_STYLE}>
                  {this.state.email.message}
                </span>
              </Col>
            </FormGroup>
            <FormGroup>
              <Col sm={2}>&nbsp;</Col>
              <Col sm={5}>
                <InputGroup>
                  <InputGroup.Addon>
                    <span className="fa fa-phone" />
                  </InputGroup.Addon>
                  <FormControl
                    type="phone"
                    id="phone"
                    className="form-control"
                    value={this.state.phone.value}
                    placeholder="Téléphone fixe"
                    onChange={(event) => this.inputChangeHandler(event)}
                  />
                </InputGroup>
                <span style={UIConstants.ERROR_SPAN_STYLE}>
                  {this.state.phone.message}
                </span>
              </Col>
              <Col sm={5}>
                <InputGroup>
                  <InputGroup.Addon>
                    <span className="fa fa-mobile-phone" />
                  </InputGroup.Addon>
                  <FormControl
                    type="phone"
                    id="cellular"
                    className="form-control"
                    value={this.state.cellular.value}
                    placeholder="Téléphone portable"
                    onChange={(event) => this.inputChangeHandler(event)}
                  />
                </InputGroup>
                <span>{this.state.cellular.message}</span>
              </Col>
            </FormGroup>
            * champs obligatoires
            <Button
              type="submit"
              disabled={!this.validateForm()}
              className="btn btn-block btn-primary mt-lg"
            >
              <span className="fa fa-user-plus" />
              &nbsp;Créer
            </Button>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={this.props.onHide}>Fermer</Button>
        </Modal.Footer>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Modal/NewUserModal.js